import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { BtnClasses, IconButton } from '@tcweb/connect-ui';
import { Component, JSX } from 'solid-js';

export interface FxBreaklinesPublishAllButtonProps {
  readonly workspaceId: string;
}

export const FxBreaklinesPublishAllButton: Component<
  FxBreaklinesPublishAllButtonProps
> = (props): JSX.Element => {
  const fxWorkspace = useFxWorkspaceContext();

  const stopTreeRowInteraction = (event: Event): void => {
    event.stopPropagation();
  };

  const handlePublishAll = (event: MouseEvent): void => {
    stopTreeRowInteraction(event);
    fxWorkspace.publishAllBreaklines(props.workspaceId);
  };

  return (
    <span class="inline-flex" onPointerDown={stopTreeRowInteraction}>
      <IconButton
        color={BtnClasses.TERTIARY}
        icon="tc-icon-launch"
        size="icon-medium"
        data-cy={`fx-breaklines-publish-all-${props.workspaceId}`}
        title={t('mobileMapping.fxWorkspace.breaklines.publishAll')}
        clicked={handlePublishAll}
      />
    </span>
  );
};
